import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { Autocomplete, TextField, Typography, useTheme, Avatar } from '@mui/material'

import { useGetUsers } from 'src/hooks'
import { IAccountUserInviteFormDto, IProfileUserResponse } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'

const UsersSearchInput = () => {
  const [t] = useTranslation()
  const { data: users, mutate: getUsers, isLoading } = useGetUsers()
  const { errors, values, setFieldValue } = useFormikContext<IAccountUserInviteFormDto>()
  const theme = useTheme()

  const handleEmailChange = (e: any, value: string | IProfileUserResponse | null) => {
    const query = typeof value === 'string' ? value : !!value ? value.email : ''
    getUsers({ query })
    setFieldValue('email', query)
  }

  return (
    <Autocomplete
      disablePortal
      id="email"
      freeSolo
      options={users?.data ?? []}
      getOptionLabel={(option) => (typeof option === 'string' ? option : option.email)}
      loading={isLoading}
      onInputChange={handleEmailChange}
      fullWidth
      renderOption={(props, option) => (
        <li {...props}>
          <Avatar
            style={{ width: 30, height: 30, marginRight: 10 }}
            alt={option.email}
            src={option.image_small || option.image}
          />
          <Typography component="h4">{option.email}</Typography>
        </li>
      )}
      value={values.email}
      renderInput={(params) => (
        <TextField
          {...params}
          autoComplete="off"
          variant="standard"
          label={t('email-input-label.v') + '*'}
          helperText={errors.email && <HelperWrapper t={errors.email} />}
          FormHelperTextProps={{ sx: { color: theme.palette.custom.warning2 } }}
        />
      )}
    />
  )
}

export { UsersSearchInput }
